import { render, staticRenderFns } from "./BadgesPage.vue?vue&type=template&id=15d3ad0e&scoped=true&lang=pug&"
import script from "./BadgesPage.vue?vue&type=script&lang=js&"
export * from "./BadgesPage.vue?vue&type=script&lang=js&"
import style0 from "./BadgesPage.vue?vue&type=style&index=0&id=15d3ad0e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15d3ad0e",
  null
  
)

export default component.exports